<template>
    <div class='date-picker'
        @click.stop>
        <div class="el-ipt"
            @click="elIptClick">
            <el-input readonly>
                <i slot="prefix" class="el-icon-date"/>
                <i slot="suffix"
                    class="el-icon-arrow-down"
                    :style="{ transform: isDown ? 'rotate(0)' : 'rotate(180deg)' }"/>
            </el-input>
            <span class="el-ipt__val">
                <date-ellipsis :dateCache="dateCache"/>
            </span>
        </div>
        <transition name="fade">
            <div v-if="!isDown"
                class="date-picker__inner">
                <div class="date-picker__inner__item__wrapper">
                    <span v-for="i in 31"
                        :key="i"
                        :class="{
                            'is-selected': dateCache.includes(i)
                        }"
                        @click="saveDate(i)">
                        <span>{{ i }}</span>
                    </span>
                </div>
                <div class="date-picker__inner__btn__wrapper">
                    <button class="text-btn fs-12 pl-0 pr-13"
                        @click="clearDate">清空</button>
                    <el-button type="primary"
                        size="mini"
                        @click="confirm">确认</el-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { createComponent } from '@vue/composition-api'
import DateEllipsis from '../../components/date_ellipsis.vue'

export default createComponent({
    props: {
        dateCache: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            iptVal: '',
            isDown: true
        }
    },

    created() {
        document.addEventListener('click', this.close)
        this.$nextTick(() => {
            this.sortDateCache([].concat(this.dateCache))
        })
    },

    beforeDestroy() {
        document.removeEventListener('click', this.close)
    },

    methods: {
        close() {
            this.isDown = true
        },

        setDateCache(d) {
            this.$emit('update:dateCache', d)
        },

        elIptClick() {
            this.isDown = !this.isDown
        },

        sortDateCache(cache) {
            const dCache = cache.sort((a, b) => a - b)
            this.setDateCache(dCache)
            this.setIptVal(dCache)
        },

        setIptVal(dCache) {
            if (dCache.length === 0) {
                this.iptVal = ''
            } else {
                this.iptVal = `每月 ${dCache.join('、')}日`
            }
        },

        saveDate(i) {
            let cache
            if (this.dateCache.includes(i)) {
                cache = this.dateCache.filter(num => num !== i)
            } else {
                cache = this.dateCache.concat(i)
            }
            this.sortDateCache(cache)
        },

        clearDate() {
            this.sortDateCache([])
        },

        confirm() {
            this.close()
        }
    },

    components: {
        DateEllipsis
    }
})
</script>

<style lang="scss" scoped>
.date-picker {
    position: relative;
    width: 331px;
    color: #333;
    ;
    z-index: 1;

    .el-ipt {
        position: relative;
        z-index: 1;
        cursor: pointer;

        ::v-deep .el-input {
            width: 100%;

            &__inner {
                cursor: pointer;
            }
        }

        &__val {
            position: absolute;
            left: 30px;
            top: 50%;
            transform: translateY(-50%);
            width: 275px;
        }
    }

    .el-icon-arrow-down {
        transition: transform .25s;
    }

    &__inner {
        position: absolute;
        width: 100%;
        height: 232px;
        left: 0;
        top: 40px;
        background-color: #fff;
        border: 1px solid #ddd;
        border-top: none;
        border-radius: 4px;
        font-size: 12px;

        &__item__wrapper {
            display: flex;
            flex-wrap: wrap;
            height: 200px;

            > span {
                flex: 0 0 47px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                cursor: pointer;

                &.is-selected {
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 24px;
                        height: 24px;
                        transform: translate(-50%, -50%);
                        background-color: #009688;
                        border-radius: 50%;
                    }

                    > span {
                        position: relative;
                        color: #fff;
                        z-index: 1;
                    }
                }
            }
        }

        &__btn__wrapper {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 32px;
            padding: 0 8px;
            border-top: 1px solid #ddd;

            ::v-deep button.el-button {
                width: 50px;
                height: 24px;
                padding: 0;
            }
        }
    }
}

.fade-enter-active, .fade-leave-active {
  transition: all .25s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(-40px);
}
</style>
